import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { ButtonSpinner } from "../../../../../../components/ButtonSpinner/ButtonSpinner";
import Wizard from "../../../../../../components/Wizard/Wizard";
import { useValidator } from "../../../../../../hooks/useValidator";
import { useLang } from "../../../../../../language";
import { SeccionDatosGenerales } from "./SeccionDatosGenerales";
import { SeccionDatosFacturacion } from "./SeccionDatosFacturacion";
import { SeccionOtrosDatos } from "./SeccionOtrosDatos";
import { SeccionFechaCalendario } from "./SeccionFechaCalendario";

export const WizardNuevoAlquiler = ({ formInscripcion, handleInputInscripcion, fetchAlquileresGET, formValuesSearch,
    handleFormInscripcion, isGratuito, fetchPersonaEntidadPOST, fetchPersonaEntidadPOSTData }: any) => {

    const Lang = useLang()

    const [currentTarifa, setcurrentTarifa] = useState<any>({});

    const listWizard: any = [Lang('DATOS_GENERALES'), Lang('FECHAS'), Lang('FACTURACION'), Lang('OTROS_DATOS')]

    const [indexFocusWizard, setIndexFocusWizard] = useState(0);

    const [valuesValidationPersona, handleValidationPersona, handleResetValidationPersona] = useValidator({
        idpersona: { isOk: true, msgError: [`La persona es obligatoria.`] },
    })

    const [valuesValidationEntidad, handleValidationEntidad, handleResetValidationEntidad] = useValidator({
        idpersonaentidad: { isOk: true, msgError: [`La entidad es obligatoria.`] },
    })

    function handleSubmitNextSection() {

        // if (handleValidationPersona(formInscripcion) &&
        //     ((formInscripcion.abona === 'E' && handleValidationEntidad(formInscripcion)) || formInscripcion.abona === 'P')
        // ) {

        setIndexFocusWizard((index: any) => isGratuito ? index + 2 : index + 1)
        // }
    }

    function handleSubmitNextToStep3() {

        // if (isGratuito || (!isGratuito && handleValidationStep2(formInscripcion))) {

        setIndexFocusWizard((index: any) => index + 1)
        // }
    }

    const handleSubmitCrearInscripcion = () => {
        fetchPersonaEntidadPOST({
            body: {
                ...formInscripcion,
                inputtotalimportebase: currentTarifa.totalimportebase,
                inputtotalimporteiva: (currentTarifa.importeiva / 100 * Number(currentTarifa.totalimportebase)).toFixed(2),
                idiva: currentTarifa.idiva,
            }
        })
    }

    const [messageValid, setmessageValid] = useState({
        status: 0,
        message: ''
    });

    const [changeTarifaFlag, setchangeTarifaFlag] = useState(false);

    return (
        <>
            <Wizard>

                <Wizard.Header
                    listWizard={listWizard}
                    indexFocusWizard={indexFocusWizard}
                    setIndexFocusWizard={setIndexFocusWizard}
                />

                <Wizard.Body indexFocusWizard={indexFocusWizard}>

                    <section className='bg-white overflow-hidden'>
                        <div className="container animate__faster animate__animated animate__fadeInLeftModal border-start border-bottom border-end">
                            <div className="row py-3 py-lg-3 px-3 justify-content-center bg-FAFAFA">

                                <div className="col-12">

                                    <div className="row my-3 justify-content-center">
                                        <SeccionDatosGenerales
                                            formInscripcion={formInscripcion}
                                            valuesValidationPersona={valuesValidationPersona}
                                            handleFormInscripcion={handleFormInscripcion}
                                            handleInputInscripcion={handleInputInscripcion}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <Modal.Footer className='border-0 d-flex justify-content-between'>
                            <div></div>
                            <ButtonSpinner
                                variant="secondary" type="submit" className="me-2"
                                handleSubmit={handleSubmitNextSection} fetchDataLoading={[false]}
                                value={Lang('CONTINUAR')}
                            />
                        </Modal.Footer>

                    </section>

                    <section className='bg-white overflow-hidden'>
                        <div className="container animate__faster animate__animated animate__fadeInLeftModal border-start border-bottom border-end">
                            <div className="row py-3 py-lg-3 px-3 justify-content-center bg-FAFAFA">

                                <div className="col-12">

                                    <div className="row my-3">
                                        <SeccionFechaCalendario
                                            handleFormInscripcion={handleFormInscripcion}
                                            formInscripcion={formInscripcion}
                                            messageValid={messageValid}
                                            setmessageValid={setmessageValid}
                                        />

                                    </div>
                                </div>

                            </div>
                        </div>

                        <Modal.Footer className='border-0 d-flex justify-content-between'>
                            <Button variant="outline-secondary" onClick={() => setIndexFocusWizard((index: any) => index - 1)} className='px-3'>
                                {Lang('VOLVER')}
                            </Button>
                            <ButtonSpinner
                                variant="secondary" type="submit" className="me-2"
                                handleSubmit={handleSubmitNextSection} fetchDataLoading={[false]}
                                value={Lang('CONTINUAR')} disabled={messageValid.status !== 200}
                            />
                        </Modal.Footer>

                    </section>

                    <section className='bg-white overflow-hidden'>
                        <div className="container animate__faster animate__animated animate__fadeInLeftModal border-start border-bottom border-end">
                            <div className="row py-3 py-lg-3 px-3 justify-content-center bg-FAFAFA">

                                <div className="col-12">

                                    <div className="row my-3">

                                        <SeccionDatosFacturacion
                                            formInscripcion={formInscripcion}
                                            valuesValidationPersona={valuesValidationPersona}
                                            handleFormInscripcion={handleFormInscripcion}
                                            handleInputInscripcion={handleInputInscripcion}
                                            currentTarifa={currentTarifa}
                                            setcurrentTarifa={setcurrentTarifa}
                                            changeTarifaFlag={changeTarifaFlag}
                                            setchangeTarifaFlag={setchangeTarifaFlag}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <Modal.Footer className='border-0 d-flex justify-content-between'>
                            <Button variant="outline-secondary" onClick={() => setIndexFocusWizard((index: any) => index - 1)} className='px-3'>
                                {Lang('VOLVER')}
                            </Button>
                            <ButtonSpinner
                                variant="secondary" type="submit" className="me-2"
                                handleSubmit={handleSubmitNextToStep3} fetchDataLoading={[false]}
                                value={Lang('CONTINUAR')}
                            />
                        </Modal.Footer>

                    </section>

                    <section className='bg-white overflow-hidden'>
                        <div className="container animate__faster animate__animated animate__fadeInLeftModal border-start border-bottom border-end">
                            <div className="row py-3 py-lg-3 px-3 justify-content-center bg-FAFAFA">

                                <div className="col-12">

                                    <div className="row my-3">

                                        <SeccionOtrosDatos
                                            formInscripcion={formInscripcion}
                                            valuesValidationPersona={valuesValidationPersona}
                                            handleFormInscripcion={handleFormInscripcion}
                                            handleInputInscripcion={handleInputInscripcion}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <Modal.Footer className='border-0 d-flex justify-content-between'>
                            <Button variant="outline-secondary" onClick={() => setIndexFocusWizard((index: any) => isGratuito ? index - 2 : index - 1)} className='px-3'>
                                {Lang('VOLVER')}
                            </Button>
                            <ButtonSpinner
                                variant="secondary" type="submit" className="me-2"
                                handleSubmit={handleSubmitCrearInscripcion} fetchDataLoading={[fetchPersonaEntidadPOSTData?.loading]}
                                value={Lang('GUARDAR')} icon={<FontAwesomeIcon icon={faSave} />}
                            />
                        </Modal.Footer>

                    </section>

                </Wizard.Body>

            </Wizard>
        </>
    )
};
